<template>
  <BaseModalEditCreate
    v-if="isOpen"
    @dismissChanges="onDismissChanges"
    :disable="mode != 'edit'"
    @save="onSave"
    maxWidth="extra"
    :isModified="shouldWarnBeforeClose"
    :title="isNew ? $t('common.actions.create') : modifiedData?.materialAlterCode.alterCode.name">
    <template #form>
      <div v-if="competitorAlterCode && modifiedData" class="w-full h-full overflow-y-auto">
        <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
          <tbody>
            <BaseDetailsTableRow :name="$t('material.competitor')" :mode="mode">
              <BaseSelectDropdown
                v-if="dropDownCompetitors && dropDownCompetitors.length > 0"
                :items="dropDownCompetitors"
                :selected-item="selectedCompetitor"
                name="competitor"
                flat
                size="sm"
                :mode="mode"
                clearable
                show-error-as-tooltip
                :error="$v.competitorId.required.$invalid ? $v.competitorId.required.$message : ''"
                @update:selected="handleCompetitorSelection" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.alterCodeType')" :mode="mode">
              <BaseSelectDropdown
                v-if="dropDownAlterCodeTypes && dropDownAlterCodeTypes.length > 0"
                :items="dropDownAlterCodeTypes"
                :selected-item="selectedAlterCodetype"
                name="alterCodeType"
                flat
                size="sm"
                mode="view" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.name')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.alterCode.name"
                color="base"
                :mode="mode"
                flat
                show-error-as-tooltip
                :error="$v.name.required.$invalid ? $v.name.required.$message : ''"
                class="w-full" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.code')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.alterCode.code"
                color="base"
                :mode="mode"
                show-error-as-tooltip
                :error="$v.code.required.$invalid ? $v.code.required.$message : ''"
                flat />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.smallCode')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.shortCode"
                color="base"
                :mode="mode"
                flat />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.measurementUnit')" :mode="mode">
              <BaseSelectDropdown
                v-if="dropdownMeasurementUnits && dropdownMeasurementUnits.length > 0"
                :items="dropdownMeasurementUnits"
                :selected-item="selectedMeasurementUnit"
                name="measurementUnit"
                flat
                size="sm"
                :mode="mode"
                clearable
                show-error-as-tooltip
                :error="
                  $v.measurementUnitId.required.$invalid
                    ? $v.measurementUnitId.required.$message
                    : ''
                "
                @update:selected="handleMeasurementSelection" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.relationFactor')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.relationFactor"
                color="base"
                :mode="mode"
                flat
                type="number"
                show-error-as-tooltip
                :error="
                  $v.relationFactor.minValue.$invalid ? $v.relationFactor.minValue.$message : ''
                " />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.minSalesQuantity')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.minSalesQuantity"
                color="base"
                :mode="mode"
                flat
                type="number" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.lotStart')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.lotStart"
                color="base"
                :mode="mode"
                flat />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.lotFinish')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.lotFinsh"
                color="base"
                :mode="mode"
                flat />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.dimension', { 'number': 1 })" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.dimension1"
                color="base"
                :mode="mode"
                flat
                type="number" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.dimension', { 'number': 2 })" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.dimension2"
                color="base"
                :mode="mode"
                flat
                type="number" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.dimension', { 'number': 3 })" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.dimension3"
                color="base"
                :mode="mode"
                flat
                type="number" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('baseObject.sequence')" :mode="mode">
              <BaseInput
                v-model="modifiedData.materialAlterCode.sequence"
                color="base"
                :mode="mode"
                flat
                type="number"
                show-error-as-tooltip
                :error="
                  $v.sequence.minValue.$invalid
                    ? $v.sequence.minValue.$message
                    : $v.sequence.uniqueSequence.$invalid
                      ? $v.sequence.uniqueSequence.$message
                      : ''
                " />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.quantityTotalizer')" :mode="mode">
              <BaseTableCellStatus
                v-if="mode == 'view'"
                :item="
                  modifiedData.materialAlterCode.quantityTotalizer
                    ? modifiedData.materialAlterCode.quantityTotalizer
                    : 0
                " />
              <BaseToggle
                v-else
                :label="$t('material.quantityTotalizer')"
                name="quantityTotalizer"
                v-model="modifiedData.materialAlterCode.quantityTotalizer" />
            </BaseDetailsTableRow>

            <BaseDetailsTableRow :name="$t('material.default')" :mode="mode">
              <BaseTableCellStatus
                v-if="mode == 'view'"
                :item="modifiedData.isDefault ? modifiedData.isDefault : 0" />
              <BaseToggle
                v-else
                :label="$t('material.default')"
                name="default"
                v-model="modifiedData.isDefault" />
            </BaseDetailsTableRow>
          </tbody>
        </table>
      </div>
    </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useLookupsStore } from '@/stores/lookups';
import { helpers, minValue, required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { deepCopy } from '@/utils/data';
import BaseInput from '../common/BaseInput.vue';
import BaseToggle from '../common/BaseToggle.vue';
import BaseSelectDropdown from '../common/BaseSelectDropdown.vue';
import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseTableCellStatus from '../common/BaseTableCellStatus.vue';
import BaseModalEditCreate from '../common/BaseModalEditCreate.vue';
import type { CompetitorMaterial } from '@/types/Materials';
import type { SelectDropdownItem } from '@/types/Base';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  competitorAlterCode: CompetitorMaterial;
  isOpen: boolean;
  isNew: boolean;
  mode: 'view' | 'edit';
  sequenceList?: number[];
}>();

const emit = defineEmits(['close', 'save']);

const modifiedData = ref<CompetitorMaterial>(
  deepCopy<CompetitorMaterial>(props.competitorAlterCode)
);
const selectedMeasurementUnit = ref<SelectDropdownItem | null>(null);
const selectedAlterCodetype = ref<SelectDropdownItem | null>(null);
const selectedCompetitor = ref<SelectDropdownItem | null>(null);

const { dropdownMeasurementUnits, dropDownAlterCodeTypes, dropDownCompetitors } =
  storeToRefs(useLookupsStore());

function initDropdowns() {
  if (modifiedData.value) {
    const measurementValue = dropdownMeasurementUnits.value.find(
      (item) => item.value == modifiedData.value?.materialAlterCode.measurementUnitId
    );
    if (measurementValue) selectedMeasurementUnit.value = measurementValue;
    else selectedMeasurementUnit.value = null;

    const alterCodeTypeValue = dropDownAlterCodeTypes.value.find(
      (item) => item.value == modifiedData.value?.materialAlterCode.alterCode.alterCodeTypeId
    );
    if (alterCodeTypeValue) selectedAlterCodetype.value = alterCodeTypeValue;
    else selectedAlterCodetype.value = null;

    const competitorValue = dropDownCompetitors.value.find(
      (item) => item.value == modifiedData.value?.competitor.id
    );
    if (competitorValue) selectedCompetitor.value = competitorValue;
    else selectedCompetitor.value = null;
  }
}

function handleMeasurementSelection(item: SelectDropdownItem) {
  if (!modifiedData.value) return;
  selectedMeasurementUnit.value = item ? item : null;
  modifiedData.value.materialAlterCode.measurementUnitId = item ? (item.value as string) : '';
  modifiedData.value.materialAlterCode.measurementUnit.name = item ? (item.name as string) : '';
  validationModel.value.measurementUnitId = item ? (item.value as string) : '';
}

function handleCompetitorSelection(item: SelectDropdownItem) {
  if (!modifiedData.value) return;
  selectedCompetitor.value = item ? item : null;
  modifiedData.value.competitorId = item ? (item.value as string) : '';
  modifiedData.value.competitor.code = item ? (item.name as string) : '';
  validationModel.value.competitorId = item ? (item.value as string) : '';
}

const shouldWarnBeforeClose = ref<boolean>(false);

const validationModel = ref({
  name: modifiedData.value.materialAlterCode.alterCode.name || '',
  code: modifiedData.value.materialAlterCode.alterCode.code || '',
  measurementUnitId: modifiedData.value.materialAlterCode.measurementUnitId || null,
  competitorId: modifiedData.value.competitorId || null,
  relationFactor: modifiedData.value.materialAlterCode.relationFactor || null,
  sequence: modifiedData.value.materialAlterCode.sequence || null,
});

const uniqueSequence = (value: number | null) => {
  if (value === null) return true;
  if (!props.sequenceList) return true;
  const originalSequence = props.competitorAlterCode.materialAlterCode.sequence;
  const otherSequences = props.sequenceList.filter((seq) => seq !== originalSequence);
  return !otherSequences.includes(value);
};

const { t: $t } = useI18n({ useScope: 'global' });
const rules = computed(() => ({
  name: { required: helpers.withMessage($t('messages.errors.requiredField'), required) },
  code: { required: helpers.withMessage($t('messages.errors.requiredField'), required) },
  measurementUnitId: {
    required: helpers.withMessage($t('messages.errors.requiredField'), required),
  },
  competitorId: { required: helpers.withMessage($t('messages.errors.requiredField'), required) },
  relationFactor: {
    minValue: helpers.withMessage($t('messages.errors.greaterThan0'), minValue(0.01)),
  },
  sequence: {
    minValue: helpers.withMessage($t('messages.errors.greaterThan0'), minValue(1)),
    uniqueSequence: helpers.withMessage($t('messages.errors.sequenceMustBeUnique'), uniqueSequence),
  },
}));
const $v = useVuelidate(rules, validationModel, { $lazy: true, $scope: false });

function onSave() {
  $v.value.$touch();
  if ($v.value.$invalid) return;

  shouldWarnBeforeClose.value = false;
  emit('save', modifiedData.value);
  $v.value.$reset();
}

function onDismissChanges() {
  modifiedData.value = deepCopy<CompetitorMaterial>(props.competitorAlterCode);
  initDropdowns();
  $v.value.$reset();
  emit('close');
}

watch(
  () => modifiedData.value,
  (newData) => {
    validationModel.value.name = newData.materialAlterCode.alterCode.name || '';
    validationModel.value.code = newData.materialAlterCode.alterCode.code || '';
    validationModel.value.measurementUnitId = newData.materialAlterCode.measurementUnitId || null;
    validationModel.value.competitorId = newData.competitorId || '';
    validationModel.value.relationFactor = newData.materialAlterCode.relationFactor || null;
    validationModel.value.sequence = newData.materialAlterCode.sequence || null;

    shouldWarnBeforeClose.value =
      JSON.stringify(modifiedData.value) !== JSON.stringify(props.competitorAlterCode);
  },
  { deep: true }
);

watch(
  () => props.competitorAlterCode,
  (newData) => {
    modifiedData.value = deepCopy<CompetitorMaterial>(newData);
    initDropdowns();
  }
);

onMounted(async () => {
  modifiedData.value = deepCopy<CompetitorMaterial>(props.competitorAlterCode);
  initDropdowns();
});
</script>
